import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "prehang-form" }
const _hoisted_2 = { class: "ph-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Jambs", -1)
const _hoisted_4 = { class: "ph-input-group ph-two-col" }
const _hoisted_5 = { class: "form-group text-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "additionalJambs" }, "Additional Jambs:", -1)
const _hoisted_7 = {
  key: 0,
  class: "ph-section"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Stops", -1)
const _hoisted_9 = { class: "ph-input-group ph-two-col" }
const _hoisted_10 = { class: "form-group text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "additionalStops" }, "Additional Stops:", -1)

import { PreHangSelections } from '@/services/prehang-classes/ph-selections';
    import PreHangSelect from '../inputs/PreHangSelect.vue';
    import { ref, watch, onMounted } from 'vue';
    import { PreHangOption } from '@/types/preHang';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'JambsForm',
  props: {
        ph: { type: PreHangSelections, required: true }
    },
  emits: ['updatePreHang'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const jambsQty = ref<number>(0)
    const stopsQty = ref<number>(0)

    watch(() => props.ph.JambsStops.additionalJambs, () => {
        if(props.ph.JambsStops.additionalJambs != jambsQty.value) {
            jambsQty.value = props.ph.JambsStops.additionalJambs
        }
    }, {immediate: true})

    watch(() => props.ph.JambsStops.additionalStops, () => {
        if(props.ph.JambsStops.additionalStops != stopsQty.value) {
            stopsQty.value = props.ph.JambsStops.additionalStops
        }
    }, {immediate: true})

    watch(jambsQty, () => {
        if(jambsQty.value != props.ph.JambsStops.additionalJambs) {
            props.ph.JambsStops.updateJambsCount(jambsQty.value)
            emits('updatePreHang')
        }
    })

    watch(stopsQty, () => {
        if(stopsQty.value != props.ph.JambsStops.additionalStops) {
            props.ph.JambsStops.updateStopsCount(stopsQty.value)
            emits('updatePreHang')
        }
    })

    function onSelect(option: PreHangOption, field: string) {
        if(field == 'customJambWidth') {
            props.ph?.JambsStops.updateCustomJambWidth(option)
        } else {
            props.ph?.updateSelection(option, field)
        }
        if(jambsQty.value > 0 || stopsQty.value > 0) {
            emits('updatePreHang')
        }
    }

    onMounted(() => {
        jambsQty.value = props.ph.JambsStops.additionalJambs
        stopsQty.value = props.ph.JambsStops.additionalStops
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(PreHangSelect, {
          fieldName: "jambMaterial",
          label: "Jamb Material",
          options: props.ph.activeOptions?.jambMaterial,
          value: props.ph.selections.jambMaterial || null,
          onSelect: onSelect
        }, null, 8, ["options", "value"]),
        _createVNode(PreHangSelect, {
          fieldName: "jambType",
          label: "Jamb Type",
          options: props.ph.activeOptions?.jambType,
          value: props.ph.selections.jambType || null,
          onSelect: onSelect
        }, null, 8, ["options", "value"]),
        _createVNode(PreHangSelect, {
          fieldName: "jambWidth",
          label: "Jamb Width",
          options: props.ph.activeOptions?.jambWidth,
          value: props.ph.selections.jambWidth || null,
          onSelect: onSelect
        }, null, 8, ["options", "value"]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((jambsQty).value = $event)),
            id: "additionalJambs",
            class: "form-control",
            type: "number",
            min: "0",
            max: "50",
            step: "1"
          }, null, 512), [
            [_vModelText, jambsQty.value]
          ])
        ]),
        (props.ph.selections.jambWidth.name == 'Custom')
          ? (_openBlock(), _createBlock(PreHangSelect, {
              key: 0,
              fieldName: "customJambWidth",
              label: "Custom Jamb Width",
              options: props.ph.JambsStops?.customJambWidthOptions,
              value: props.ph.JambsStops.customJambWidth || null,
              onSelect: onSelect
            }, null, 8, ["options", "value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (!props.ph.JambsStops.isBifoldDoor)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(PreHangSelect, {
              fieldName: "stop",
              label: "Stop",
              options: props.ph.activeOptions?.stop,
              value: props.ph.selections.stop || null,
              onSelect: onSelect
            }, null, 8, ["options", "value"]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stopsQty).value = $event)),
                id: "additionalStops",
                class: "form-control",
                type: "number",
                min: "0",
                max: "50",
                step: "1"
              }, null, 512), [
                [_vModelText, stopsQty.value]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})